var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJianchalujing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 15",
    clipPath: "url(#clip0_40_2279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 565",
    d: "M6.39722 1.18649C13.7645 -0.149642 13.1308 6.11346 5.77816 6.65248C-1.67786 7.19908 -1.67789 17.2201 15 14.5478",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 65",
    cx: 6.2859,
    cy: 1.08326,
    r: 1.08326,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 66",
    cx: 5,
    cy: 6.6886,
    r: 1.08106,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 67",
    cx: 6.85648,
    cy: 14.8565,
    r: 1.14359,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 68",
    cx: 14.896,
    cy: 14.5,
    r: 1,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_2279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJianchalujing);
export default __webpack_public_path__ + "static/media/jianchalujing.4038de9f6242f0263b76affcd861fd87.svg";
export { ForwardRef as ReactComponent };